import {React, useContext} from 'react'
import bg_img3 from './static/img/bg-img3.jpg'
import BreadcrumbsSection from './BreadcrumbsSection'
import OurServicesSection from './OurServicesSection'
import FeedbackSection from './FeedbackSection'
import RoutesContext from '../contexts/RoutesContext'

function ServicesPage(props) {
  let routes_context = useContext(RoutesContext)
  return (
     
    <main onLoad={routes_context.flip_card_resize}>
        
        <BreadcrumbsSection routes={routes_context.routes} page_name='Services' />
        <div className="services_banner_section">
            <div className="services_banner_inner_wrapper">
                <img src={bg_img3} alt="" />
            </div>
        </div>

        <OurServicesSection routes={routes_context.routes} setCurrentPage = {routes_context.setCurrentPage} />

        <FeedbackSection />    

    </main>
  )
}

export default ServicesPage